import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDTitleText } from '@facet-wealth/design';

export const MissingInformationOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDTitleText, size: 'md', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['label', 'payStubsLabel'], {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'sm', color: 'textDisabled' },
  }, overrideReadOnly)
  .nameOverride(['description', 'payStubsDescription'], {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);
